/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
/* eslint-disable arrow-body-style */
import { ViewModelForm, ViewModelServiceContext } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import _ from 'lodash';
import { Flex } from '@jutro/layout'
import cx from 'classnames'
import { IntlContext, TranslatorContext } from "@jutro/locale";
import CoverageSummaryAccordion from '../CoverageSummaryAccordion/CoverageSummaryAccordion';
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import metadata from './PolicyBuildingAccordion.metadata.json5';
import messages from './PolicyBuildingAccordion.messages';


function PolicyBuildingAccordion(props) {
    // US28766 and US28769
    const {   data: location, index, path: locationPath, isPolicySummary, isRenewalSummary} = props;
    const translator = useContext(TranslatorContext)
    const intlContext = useContext(IntlContext);
    const viewModelService = useContext(ViewModelServiceContext);
    
    const isBuildersRisk = () => {
        const isRisk = location.buildings.filter(e => e.coverageForm === 'TWCR');
        return (isRisk.length > 0);
    };

    const buildingHeader = (i, building, premium) => {
        const formatterCurrency = intlContext.formatNumber(premium.amount, {
            style: 'currency',
            currency: premium.currency
        });
        // DE17188
        const description = _.get(building, 'description');

        if (isBuildersRisk()) {
            return (
                <div>
                    <Flex className={styles.fullWidth}>
                        <div className={cx(styles.heading, styles.headingBold, styles.flexOneFourth)}>
                            {translator(messages.BuildingTitle)}&nbsp;&nbsp;{_.get(building, 'buildingNumber')}
                        </div>
                        <div className={cx(styles.heading, styles.flexOneFourth)}>
                            {description}
                        </div>
                    </Flex>
                </div>
            )
        }

        return (
            <div>
                <Flex className={styles.fullWidth}>
                    <div className={cx(styles.heading, styles.headingBold, styles.flexOneFourth)}>
                        {translator(messages.BuildingTitle)}&nbsp;&nbsp;{_.get(building, 'buildingNumber')}
                    </div>
                    <div className={cx(styles.heading, styles.flexOneFourth)}>
                        {description}
                    </div>
                </Flex>
            </div>
        )
    }

    const generateTopicOverrides = useCallback(() => {
        if(location === undefined) {
            return [];
        }
        const overrides = location?.buildings?.map((building, i) => {
            return {
                [`buildingCard${i}`]: {
                    title: buildingHeader( i+1,building,building.premium),
                },
                [`buildingNumber${i}`]: {
                    value: _.get(building, 'buildingNumber') === undefined ? translator(messages.NotApplicable) :  _.get(building, 'buildingNumber')
                }
            }
        });

        return Object.assign({}, ...overrides);
    }, [buildingHeader, isBuildersRisk, isRenewalSummary, location, translator, viewModelService]);

    const resolvers = {
        resolveCallbackMap: {
            buildingHeader,
            isBuildersRisk
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            CoverageSummaryAccordion,
        },
    }

    const overrideProps = {
        '@field': {           
            className:styles.customFieldStyle // DE17182
        },
        buildings: {
            data: location?.buildings, isRenewalSummary
        },
        ...generateTopicOverrides(),
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={location}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default PolicyBuildingAccordion